import PubnubInappChat from './Pubnub';

// The main inbox is always PubNub. Supabase comms is reached only via the
// dedicated ops pages (/supabase-chat, /supabase-cohort), never through here.
const InappChat = () => {
  return <PubnubInappChat />;
};

export default InappChat;
